module.exports = __webpack_public_path__ + "static/media/C2.83d72b51.webp";